export default __webpack_public_path__ + "static/media/nex.d14208e2.png";